import { env } from './env';

/** Typed, grouped application configuration. Import this — never read `import.meta.env`. */
export const appConfig = {
  app: {
    name: env.VITE_APP_NAME,
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
  },
  api: {
    baseUrl: env.VITE_API_BASE_URL.replace(/\/+$/, ''),
    timeoutMs: env.VITE_API_TIMEOUT_MS,
  },
} as const;

export type AppConfig = typeof appConfig;
